module.exports = __webpack_public_path__ + "img/4.27122ee0.jpg";